import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Truck({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M10 4H14C14.55 4 15 4.44 15 5V15H2M5 19.41H3C2.448 19.41 2 18.96 2 18.41V12.99M15 7H19.323C19.723 7 20.093 7.24 20.243 7.62L21.843 11.63C21.933 11.86 21.983 12.11 21.983 12.37V18.318C21.983 18.868 21.533 19.318 20.983 19.318H19.143M16 19.42H8.17M22 14H18V10H21.2M2 4H7M2 7H5M3 10H2M18.704 18.29C19.314 18.9 19.314 19.91 18.704 20.53C18.084 21.14 17.074 21.14 16.464 20.53C15.844 19.91 15.844 18.9 16.464 18.29C17.074 17.67 18.084 17.67 18.704 18.29ZM7.704 18.29C8.314 18.9 8.314 19.91 7.704 20.53C7.084 21.14 6.074 21.14 5.464 20.53C4.844 19.91 4.844 18.9 5.464 18.29C6.074 17.67 7.084 17.67 7.704 18.29Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Truck;